"use client";

import { createAbsoluteUrl } from "@/service/url";
import { createPath } from "@/service/routing/routing";
import { getAssetImage } from "@/service/image/asset";
import { remediumOrganization } from "@/components/common/structured-data/organization-structured-data";
import {
  contentDates,
  JsonLd,
  paywalledPart,
} from "@/components/common/structured-data/json-ld";

export const StructuredData = ({
  specialization: {
    slug,
    title,
    seo: { title: seoTitle, description },
    createdAt,
    updatedAt,
  },
}: {
  specialization: ResidencySpecializationVM;
}) => {
  return (
    <JsonLd
      data={{
        "@type": "Article",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": createAbsoluteUrl(
            createPath("residency_encyclopedia.show", { slug }),
          ),
        },
        headline: seoTitle || title,
        publisher: remediumOrganization,
        author: remediumOrganization,
        description: description || undefined,
        image: getAssetImage("/residencyEncyclopedia/header.png"),
        ...contentDates(createdAt, updatedAt),
        ...paywalledPart,
      }}
    />
  );
};
